import { Patient, PatientAPI } from './patient';

export class DemandeContact {
  id: number;
  objet: string;
  message: string;
  pdf?: string;
  patient_id?: number;
  patient?: Patient;
  date?: Date;

  constructor(
    id: number,
    objet: string,
    message: string,
    pdf?: string,
    patient_id?: number,
    patient?: Patient,
    date?: Date,
  ) {
    this.id = id;
    this.objet = objet;
    this.message = message;
    this.pdf = pdf;
    this.patient_id = patient_id;
    this.patient = patient;
    this.date = date;
  }

  static factory(demandeContactAPI: DemandeContactAPI): DemandeContact {
    return new DemandeContact(
      demandeContactAPI.id,
      demandeContactAPI.objet,
      demandeContactAPI.message,
      demandeContactAPI.pdf,
      demandeContactAPI.patient_id,
      demandeContactAPI.patient
        ? Patient.factory(demandeContactAPI.patient)
        : undefined,
      demandeContactAPI.created_at
        ? new Date(demandeContactAPI.created_at)
        : undefined,
    );
  }

  toApi(): DemandeContactAPI {
    return {
      id: this.id,
      objet: this.objet,
      message: this.message,
      pdf: this.pdf,
      patient_id: this.patient_id ?? this.patient?.id,
      created_at: this.date ? this.date.toISOString() : undefined,
    };
  }
}

export type DemandeContactAPI = {
  id: number;
  objet: string;
  message: string;
  pdf?: string;
  patient_id?: number;
  patient?: PatientAPI;
  created_at?: string;
};

export class DemandeContactList {
  data: DemandeContact[];
  total: number;
  currentPage?: number;
  lastPage?: number;
  perPage?: number;
  from?: number;
  to?: number;

  constructor(
    data: DemandeContact[],
    total: number,
    currentPage?: number,
    lastPage?: number,
    perPage?: number,
    from?: number,
    to?: number,
  ) {
    this.data = data;
    this.total = total;
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.perPage = perPage;
    this.from = from;
    this.to = to;
  }

  static factory(
    demandeContactListAPI: DemandeContactListAPI,
  ): DemandeContactList {
    return new DemandeContactList(
      demandeContactListAPI.data.map((demandeContactAPI: DemandeContactAPI) =>
        DemandeContact.factory(demandeContactAPI),
      ),
      demandeContactListAPI.total,
      demandeContactListAPI.current_page,
      demandeContactListAPI.last_page,
      demandeContactListAPI.per_page,
      demandeContactListAPI.from,
      demandeContactListAPI.to,
    );
  }
}

export type DemandeContactListAPI = {
  data: DemandeContactAPI[];
  total: number;
  current_page?: number;
  last_page?: number;
  per_page?: number;
  from?: number;
  to?: number;
};
